import React, { Component } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import config from '../../../config/config';

import '../../../static/scss/components/tab.scss';

type ParentTheme = '' | 'secondary';
type Theme = 'light' | 'pale-grey' | 'dark' | 'light-dashboard';
type Href = string;

type Props = {|
  active?: number, // eslint-disable-line react/no-unused-prop-types
  redirectHandler?: Href => {},
  onTabChange?: () => {},
  // This should only allow children of TabItem
  children: any,
  parentTheme?: ParentTheme,
  theme?: Theme,
  hideIndices?: ?(number[]),
  animate?: boolean
|};

type State = {
  activeTab?: number,
  changeDirection: number
};

class TabContainer extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      activeTab: props.active
    };
  }

  componentWillReceiveProps(nextProps: any) {
    this.setState({
      activeTab: nextProps.active
    });
  }

  componentWillUpdate(nextProps: Props, nextState: State) {
    if (nextState.activeTab !== this.state.activeTab) {
      /* eslint-disable react/no-will-update-set-state */
      /* eslint-disable react/no-access-state-in-setstate */
      this.setState({
        changeDirection: nextState.activeTab - this.state.activeTab
      });
    }
  }

  onClickTab(index: number) {
    // eslint-disable-next-line prefer-destructuring
    const href = this.props.children[index].props.href;

    if (href) {
      this.props.redirectHandler(href);
    } else {
      this.setState({ activeTab: index });
      this.props.onTabChange(index);
    }
  }

  render() {
    const { parentTheme, theme, hideIndices, animate } = this.props;

    const tabNav = (
      <ul className={`c-tab__nav c-tab__nav--${theme}`}>
        {this.props.children.map((el, index) => (
          <li
            key={index}
            onClick={() => {
              this.onClickTab(index);

              if (el.props.onClick) {
                el.props.onClick();
              }
            }}
            className={`
              ${
                this.state.activeTab === index
                  ? 'c-tab__nav-tab c-tab__nav-tab__active'
                  : 'c-tab__nav-tab'
              }
              ${
                hideIndices && hideIndices.includes(index)
                  ? 'c-tab__nav-tab--hide'
                  : ''
              }
            `}
          >
            {el.props.tab()}
          </li>
        ))}
      </ul>
    );

    const getParentClassName = mainTheme =>
      mainTheme === 'secondary' ? 'c-tab c-tab--secondary' : 'c-tab';

    const transitionContainerClass = 'c-tab__content__transition-container';
    const content = this.props.children[this.state.activeTab];

    return (
      <div className={getParentClassName(parentTheme)}>
        {tabNav}

        <div className="c-tab__content">
          {animate ? (
            <TransitionGroup
              className={`${transitionContainerClass} c-tab__content__transition-container--${
                this.state.changeDirection < 0 ? 'right' : 'left'
              }`}
            >
              {content && (
                <CSSTransition
                  timeout={{ enter: 400, exit: 400 }}
                  classNames="tabs-transition"
                  key={`tab-${this.state.activeTab}`}
                >
                  {React.cloneElement(content, {
                    style: {
                      ...content.props.style,
                      order: this.state.activeTab
                    }
                  })}
                </CSSTransition>
              )}
            </TransitionGroup>
          ) : (
            content
          )}
        </div>
      </div>
    );
  }
}

TabContainer.defaultProps = {
  active: 0,
  redirectHandler: (href: Href) => {
    if (!config.isTesting) {
      window.location = href;
    }
  },
  onTabChange: () => {},
  parentTheme: 'primary',
  theme: '',
  hideIndices: [],
  animate: false
};

export default TabContainer;
